import React, {Component, useState} from 'react'
import { connect } from 'react-redux'
import Home from "./home";

class Token extends React.Component {

    render() {
        const {token, name} = this.props
        return (
            //token !== "" && n
            // ame !== "" ? <Home/> : <Navigate to={"/login"}/>
            <Home />
        )
    }
}

const mapStateToProps = state => ({
    token: state.user.token,
    name: state.user.name
})

export default connect(
    mapStateToProps,
    null
)(Token)